import { customerPageType, REFER_FRIEND_BETA_FEATURE } from './const';

import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';

export default [
  {
    path: 'refer-a-friend(/:guid)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([REFER_FRIEND_BETA_FEATURE]),
    ],
    getComponent(location, callback) {
      import(/* webpackChunkName: "refer-a-friend" */ './containers/ReferAFriendPage')
        .then(component => callback(null, component.default));
    },
    customerType: customerPageType.existing,
  },
  {
    path: 'referred-friend/:guid/*',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([REFER_FRIEND_BETA_FEATURE]),
    ],
    getComponent(location, callback) {
      import(/* webpackChunkName: "refer-a-friend" */ './containers/ReferAFriendPage')
        .then(component => callback(null, component.default));
    },
    customerType: customerPageType.new,
  },
];
